import { useEffect, useState } from 'react';

/**
 * @see https://tailwindcss.com/docs/responsive-design
 * @returns
 */
interface Breakpoints {
  sm: boolean;
  md: boolean;
  lg: boolean;
  xl: boolean;
  isMobile: boolean;
  halfHeight: boolean;
}

const getBreakpoints = (width: number, height: number) => {
  return {
    sm: width < 640,
    md: width >= 640 && width < 768,
    lg: width >= 768,
    xl: width >= 1024,
    isMobile: width <= 550,
    halfHeight: height < 768,
  } satisfies Breakpoints;
};

export const useResponsive = () => {
  const [breakpoints, setBreakpoints] = useState(
    getBreakpoints(window.innerWidth, window.innerHeight),
  );

  useEffect(() => {
    const handleResize = () => {
      // Check if one of the breakpoints has been hit
      const inBreakpoints = getBreakpoints(window.innerWidth, window.innerHeight);

      if (
        Object.entries(breakpoints).some(
          ([key, value]) => value !== inBreakpoints[key as keyof Breakpoints],
        )
      ) {
        setBreakpoints(inBreakpoints);
      }
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [breakpoints]);

  return breakpoints;
};
